'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

// Types
import type { ListItemProps } from '@/types/components/molecules/item/list'

// Helpers
import { useSettingsStore } from '@/helpers/store/settings'

// Components
const IconAtom = dynamic(() => import('@/components/atoms/icon'), { ssr: false })

const ListItemMolecule = (props: ListItemProps) => {
	// Props
	const { baseUrl, items, showHome, removeText } = props

	// Variables
	const { setPanelMenu } = useSettingsStore()
	const pathname = usePathname()

	return (
		<List
			sx={{
				display: 'inline-flex',
				flexDirection: 'column',
				gap: 0.25,
				width: 1,
				m: 0,
				p: 0,
				'& li': {
					width: 1,
					'& a': {
						width: 1,
						'& .MuiButtonBase-root': {
							p: { xs: 1, md: 2 },
							width: 1,
							borderRadius: 1,
							color: 'text.primary',
							'& .MuiListItemIcon-root': {
								minWidth: 24,
								mr: 1
							},
							'& .MuiSvgIcon-root': {
								fontSize: 24,
								color: 'grey.900'
							},
							'& .MuiTypography-root': {
								fontSize: 16,
								fontWeight: 600,
								lineHeight: 1
							}
						}
					}
				},
				'& li.is-current': {
					'& .MuiButtonBase-root': {
						bgcolor: 'grey.100',
						'& .MuiSvgIcon-root': { fontWeight: 700 },
						'& .MuiTypography-root': { fontWeight: 700 }
					}
				}
			}}
		>
			{items.map((item, index) => {
				const isHome = ['/home'].includes(item.link_value)
				const link = item.type_name === 'external' ? item.link_value : isHome ? `${baseUrl}` : ['/logout'].includes(item.link_value) ? '#' : `${baseUrl}${item.link_value}`
				const isActive = pathname.indexOf(`${link}/`) === 0
				const isCurrent = pathname === link

				if (!isHome || showHome) {
					let className = `${baseUrl !== item.link_value && isActive && 'is-active'}`
					className += isCurrent ? `${className && ' '} is-current` : ''

					return (
						<ListItem key={index} className={className} disableGutters disablePadding sx={{ '&:hover': { bgcolor: 'transparent' } }}>
							<Link href={!item.disabled ? link : '#'} onClick={() => setPanelMenu(false)}>
								<ListItemButton disabled={item.disabled} onClick={item.onClick}>
									{item.icon ? (
										<ListItemIcon>
											<IconAtom name={item.icon} />
										</ListItemIcon>
									) : null}

									<ListItemText sx={{ ...(removeText && { display: { md: 'none' } }) }}>{item.title}</ListItemText>
								</ListItemButton>
							</Link>
						</ListItem>
					)
				} else return null
			})}
		</List>
	)
}

export default ListItemMolecule
